import React from 'react';
import { portfolioData } from '../mockData';

const Education = () => {
  const { education } = portfolioData;

  return (
    <section id="education">
      <div className="label reveal">Education</div>
      <div className="entry-list">
        {education.map((item) => (
          <div className="entry reveal" key={item.degree}>
            <span className="badge">{item.graduation}</span>
            <div className="entry-header">
              <img src={item.logo} alt={`${item.institution} logo`} className="entry-logo" />
              <div className="entry-title">{item.institution}</div>
            </div>
            <div className="entry-sub">{item.degree} · {item.location}</div>
            <p className="entry-desc">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;
